/**
 * Number-over-label statistic tile.
 *
 * Same shape as the Vault's six summary cards, which is the pattern the Studio
 * metadata rows and the Guide counters approximate. Styles verbatim.
 */
import { c } from '../../styles/theme';

export interface StatCardProps {
  /** The figure. Accepts a string so callers can pass "22" or "150+". */
  value: string | number;
  label: string;
}

export default function StatCard({ value, label }: StatCardProps) {
  return (
    <div
      style={{
        border: `1px solid ${c.border}`,
        borderRadius: 10,
        padding: '10px 12px',
        background: c.surface1,
      }}
    >
      <p style={{ fontSize: 18, fontWeight: 600, margin: '0 0 2px', fontFamily: 'Space Grotesk' }}>
        {value}
      </p>
      <p style={{ fontSize: 11, color: c.text2, margin: 0 }}>{label}</p>
    </div>
  );
}
